import * as React from 'react';
import { RoundDeleteBtn } from '../input/Buttons';
import { SectionGroup } from './SectionGroup';

export interface SectionGroupDynamicProps {
    children?: any;
    deleteOnClick: (index: number) => void;
    index: number;
    header?: any;
    className?: string;
}

export function SectionGroupDynamic(props: SectionGroupDynamicProps) {
    const deleteButton = (
        <RoundDeleteBtn buttonOnClick={() => props.deleteOnClick(props.index)} />
    );

    let classes = props.className !== undefined ? props.className : '';

    return (
        <SectionGroup className={classes} header={props.header} buttons={deleteButton} >
            {props.children}
        </SectionGroup>
    );
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/uiComponents/layout/SectionGroupDynamic.tsx